import { render, staticRenderFns } from "./potentialCustomer.vue?vue&type=template&id=c2b00758&scoped=true"
import script from "./potentialCustomer.vue?vue&type=script&lang=js"
export * from "./potentialCustomer.vue?vue&type=script&lang=js"
import style0 from "./potentialCustomer.vue?vue&type=style&index=0&id=c2b00758&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b00758",
  null
  
)

export default component.exports